<style scoped lang="scss">
    .vue-dropzone {
        background: #eee;
        border: thin dashed #666;
    }
</style>

<template>
    <div class="uk-grid">
        <div class="uk-width-1-1 uk-margin-top uk-margin-bottom" v-for="document in documents" v-if="document">
            <a href="javascript:;" uk-tooltip title="Delete File" class="uk-button uk-button-danger uk-margin-left" @click="deleteDocument(document)">
                <i class="fa fa-trash"></i>
            </a>
            <a :href="`documents/download/${document.id}`" target="_blank"><span class="uk-margin-left">{{document.filename}}</span></a>
        </div>
        <div class="uk-width-1-1">
            <vue-dropzone
                    ref="dropzone"
                    :options="dropzoneOptions"
                    :useCustomSlot=true
                    @vdropzone-sending="sendingFile"
                    @vdropzone-max-files-exceeded="onMaxFilesExceeded"
                    @vdropzone-success="onSuccess"
            >
                <slot/>
            </vue-dropzone>
        </div>

    </div>
</template>

<script>
    import VueDropzone from 'vue2-dropzone'
    import {mapState} from "vuex";
    export default {
        name: "DropzoneUploader",
        components: {VueDropzone},
        props: {
            dropzoneOptions: {
                type: Object,
                required: true,
            },
            formData: {
                type: Object,
                default() {
                    return {}
                }
            },
        },
        computed: {
            documents() {
                return _.filter(this.applicationDocuments, doc => {
                    let matches = true;
                    _.each(this.formData, (value, key) => {
                        if(doc[key] != value) {
                            matches = false;
                        }
                    })
                    return matches;
                })
            },
            ...mapState('Application', {
                applicationDocuments: state => state.documents,
                applicationId: state => state.application.id,
            })
        },
        methods: {
            sendingFile(file, xhr, formData) {
                _.each(this.formData, (value, key) => {
                    formData.append(key, value);
                })
            },
            onMaxFilesExceeded(file) {
                this.$emit('onMaxFilesExceeded', file);
            },
            onSuccess(file, response) {
                console.log('response', response);
                this.$store.dispatch('Application/addDocument', { document: response.document});
                this.$refs.dropzone.removeFile(file);
            },
            getDocuments() {
              return this.documents;
            },
            async deleteDocument(doc) {
                let r = await this.$store.dispatch('Document/deleteDocument', doc.id);
                console.log('delete response', r);
                this.$emit('onDeleted', doc);
                this.$store.dispatch('Application/removeDocument', doc);
            },
        },
    }
</script>
